var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.912922C9 0.413669 8.54688 0 8 0C7.73438 0 7.48437 0.0998508 7.29687 0.271024L0.296875 6.66147C0.109375 6.83265 -7.20971e-08 7.06088 -7.45731e-08 7.30337C-7.70492e-08 7.54587 0.109375 7.7741 0.296875 7.94527L7.29687 14.3357C7.48437 14.5069 7.73437 14.6067 8 14.6067C8.54687 14.6067 9 14.1931 9 13.6938L9 0.912922Z",
    fill: "#079FF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleArrowLeft);
export default __webpack_public_path__ + "static/media/TriangleArrowLeft.7ce0c4441324063abdc6dccc5e32ae64.svg";
export { ForwardRef as ReactComponent };